import React from "react";

import icon from "../../assets/images/bulb.png";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const WorkplaceBanner = () => {
  return (
    <>
      <Link to="/main_b/independent">
        <Row className="secondary-background m-auto">
          <Col className="col-sm-2 col-2 d-flex flex-row align-items-center pl-2 pt-3 pb-3">
            <img alt="" src={icon} />
          </Col>
          <Col className="col-sm-9 col-9 small d-flex flex-row align-items-center">
            <div>
              <div className="font-weight-bold">
                Are you independent? Click Here
              </div>
            </div>
          </Col>
          <Col className="col-sm-1 col-1 accent-color d-flex flex-row align-items-center justify-content-center">
            <i className="fa fa-chevron-right" />
          </Col>
        </Row>
      </Link>
    </>
  );
};

export default WorkplaceBanner;
